import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-filter_svg__a"
        d="M10.723 5H21v2H10.723A1.99 1.99 0 019 8a1.989 1.989 0 01-1.722-1H3V5h4.278c.346-.596.984-1 1.722-1a1.99 1.99 0 011.723 1zM15 10c.738 0 1.376.404 1.723 1H21v2h-4.277c-.347.596-.985 1-1.723 1a1.992 1.992 0 01-1.723-1H3v-2h10.277c.347-.596.985-1 1.723-1zm-6 6.125c.687 0 1.293.347 1.652.875H21v2H10.79A1.993 1.993 0 019 20.125 1.993 1.993 0 017.21 19H3v-2h4.348A1.994 1.994 0 019 16.125z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-filter_svg__a"
    />
  </svg>
);
